import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, Collapse, ContentTile, CarouselVariant, MediaQuery, SliderNavColor, SliderNavVariant, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { MIN_SCREEN_WIDTH_TABLET, MIN_SCREEN_WIDTH_DESKTOP } from '../../../constants/ScreenWidthConstants';
import { SLIDE_SPACING } from '../../../constants/SliderConstants';
import { getCategoryAndTypeByTags } from '../../../util/content-lister/ContentListerUtil';
import { generateTestId } from '../../../util/TestUtil';
const TEST_ID = 'product-relevant-content';
const ProductRelevantContent = ({ content, collapsible, collapsed, title, types, categories, analyticsBannerId, }) => {
    const { t } = useTranslation([I18N_NAMESPACES.general]);
    const { mainWebShop } = useAemConfig();
    const contentSize = content.length;
    const isExtended = contentSize < 3;
    const slidesPerView = isExtended ? 2 : 3;
    const contentTileTranslations = {
        readMore: t(`${I18N_NAMESPACES.general}:readMore`),
    };
    const carouselConfig = {
        variant: CarouselVariant.CONTENT_TILE,
        arrowsConfig: {
            color: SliderNavColor.BASE,
            variant: SliderNavVariant.CIRCLE,
        },
        showPagination: true,
        configurationOverrides: {
            preventClicks: true,
            slidesPerView: 'auto',
            spaceBetween: SLIDE_SPACING.MOBILE,
            watchOverflow: true,
            shouldSwiperUpdate: true,
            breakpoints: {
                [MIN_SCREEN_WIDTH_TABLET]: {
                    slidesPerView,
                    spaceBetween: SLIDE_SPACING.MOBILE,
                },
                [MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerView,
                    spaceBetween: SLIDE_SPACING.DESKTOP,
                },
            },
        },
    };
    const slides = content.map(c => (_jsx("div", { children: _jsx(Box, { paddingBlockEnd: { md: '4' }, testId: generateTestId({ testId: TEST_ID, suffix: 'slide-' + c._id }), children: _jsx(ContentTile, { href: c.url, tags: getCategoryAndTypeByTags(mainWebShop, c.tags, types, categories), title: c.title, text: c.description, image: { src: c.image, backgroundImage: true, lazy: true }, extended: isExtended, translations: contentTileTranslations }) }) }, c._id)));
    if (!(content === null || content === void 0 ? void 0 : content.length)) {
        return null;
    }
    if (collapsible) {
        return (_jsx(Box, { paddingBlockStart: { base: collapsible ? '0' : '4', md: '0' }, paddingBlockEnd: { md: '10' }, "data-analytics-bannerid": analyticsBannerId, testId: generateTestId({ testId: TEST_ID, suffix: analyticsBannerId }), children: _jsx(Collapse, { id: "product-relevant-content-collapse", title: title, open: !collapsed, query: [MediaQuery.MOBILE, MediaQuery.TABLET_SMALL], mobileFullwidth: true, tabletFullwidth: true, desktopFullwidth: true, children: _jsx(Box, { paddingBlockStart: { base: collapsible ? '0' : '4', md: '4' }, paddingBlockEnd: { base: '6', md: '0' }, marginInline: !collapsible ? { base: '-4', md: '-6' } : undefined, testId: generateTestId({ testId: TEST_ID, suffix: 'carousel-content' }), children: _jsx(Carousel, Object.assign({}, carouselConfig, { children: slides })) }) }) }));
    }
    return (_jsxs(Box, { paddingBlockStart: { base: collapsible ? '0' : '4', md: '0' }, paddingBlockEnd: { md: '10' }, "data-analytics-bannerid": analyticsBannerId, testId: generateTestId({ testId: TEST_ID, suffix: analyticsBannerId }), children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingM", testId: generateTestId({ testId: TEST_ID, suffix: 'title' }), children: title }), _jsx(Box, { paddingBlockStart: { base: collapsible ? '0' : '4', md: '4' }, paddingBlockEnd: { base: '6', md: '0' }, marginInline: !collapsible ? { base: '-4', md: '-6' } : undefined, testId: generateTestId({ testId: TEST_ID, suffix: 'carousel-content' }), children: _jsx(Carousel, Object.assign({}, carouselConfig, { children: slides })) })] }));
};
export default ProductRelevantContent;
